export const ICON_ONLY_BUTTON_STYLES =
  "max-h-10 rounded-md bg-stone-100 p-2.5 hover:bg-stone-200 focus:outline-none focus:ring-1 focus:ring-stone-500 dark:bg-stone-700 dark:hover:bg-stone-600 ";

export const DEFAULT_ICON_COLORS = "text-stone-400";

export const ICON_ONLY_BUTTON_ICON_STYLES =
  "text-stone-500 dark:text-stone-400";

export const EXTRA_LARGE_ICON_SIZE_STYLES = "h-11 w-11";
export const LARGE_ICON_SIZE_STYLES = "h-6 w-6";
export const MEDIUM_ICON_SIZE_STYLES = "h-5 w-5";
export const SMALL_ICON_SIZE_STYLES = "h-4 w-4";
export const BUTTON_ICON_STYLES = `${DEFAULT_ICON_COLORS} justify-self-end underline hover:text-stone-600 dark:hover:text-stone-300`;

export const DIALOG_TITLE_STYLES = "text-primary text-lg font-medium leading-6";

export const CLOSE_ICON_STYLES = `${DEFAULT_ICON_COLORS} ${LARGE_ICON_SIZE_STYLES} absolute hover:text-stone-600 dark:hover:text-stone-200 closeButton`;

export const HEADER_BUTTON_STYLES = `${ICON_ONLY_BUTTON_ICON_STYLES} max-md:text-stone-400 rounded-full bg-stone-800 p-2.5 md:text-stone-500 dark:text-stone-400 hover:bg-stone-700 hover:text-stone-100`;

export const OVERLAY_TEXT_BLOCK_STYLES = "text-primary px-4 py-2";
